<template>
    <div class="footer">
        <div>
            <strong>Copyright</strong> Delivery Monsters &copy; 2020-2025
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>
